import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PtbrOperationsEditModal from './PtbrOperationsEditModal';
import getLocale from '../../../i18n/getLocale';

class PtbrOperationsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      modal_props: false,
      ptbr_operations: [],
      data_ptbr_operation: [],
      external_load: 0,
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.showModal = this.showModal.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.ptbr_operations)) {
      this.setState({ptbr_operations: newProps.ptbr_operations, modal_props: newProps.modal_props});
    }
  }
  
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      type: this.state.type,
      description: this.state.description,
      external_load: this.state.external_load,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/referencias/ptbr/operacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.props.refreshTable(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: ''}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ActionsButtons (cell, row) {    
    var botao = (
      <div className="btn-group">
        <button className="btn btn-primary btn-sm" value={cell} onClick={this.showModal}>
          <i className="fa fa-fw fa-pencil"></i>
        </button>
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  delete (event) {
    var ptbr_operation_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.PTBR.ReferenciasPTBR.tabOperacoes.deletarOperacao);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/referencias/ptbr/operacao/' + ptbr_operation_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(ptbr_operation_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRow(ptbr_operation_id) {
    var data = this.state.ptbr_operations;
    data.map(function(dado, index){
      if (dado.id == ptbr_operation_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }


  showModal(event) {
    var self = this;
    var ptbr_operation_id = event.currentTarget.value;

    var data = self.state.ptbr_operations;
    data.map(function(dado, index){
      if (dado.id == ptbr_operation_id) {
        self.setState({
          data_ptbr_operation: dado,
          modal_props: true,
        });
      }
    });
  }



  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabOperacoes.formulario.Tipo}</label>
          <input type="text" name="type" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabOperacoes.formulario.placeholder.Tipo} value={this.state.type} onChange={this.handleChange.bind(this, 'type')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabOperacoes.formulario.Descricao}:</label>
          <input type="text" name="description" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabOperacoes.formulario.placeholder.Descricao} value={this.state.description} onChange={this.handleChange.bind(this, 'description')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabOperacoes.formulario.CargaExterna}:</label>
          <Select
            className="form-field-name"
            name="external_load"
            value={this.state.external_load}
            searchable={true}
            placeholder={''}
            onChange={this.handleSelectChange.bind(this, 'external_load')}
            options={[
              {value: 0, label: this.locale.general.nao},
              {value: 1, label: this.locale.general.sim},
            ]}
            required
          />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PTBR.ReferenciasPTBR.tabOperacoes.formulario.botaoAdicionarOperacaoPTBR}</button>
      </div>
    </div>
  </form>
  <hr/>
  <BootstrapTable data={this.state.ptbr_operations} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.PTBR.ReferenciasPTBR.tabOperacoes.tabela.semOperacoesPTBR}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.PTBR.ReferenciasPTBR.tabOperacoes.tabela.ID}</TableHeaderColumn>
    <TableHeaderColumn dataField="type" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabOperacoes.tabela.Tipo}</TableHeaderColumn>
    <TableHeaderColumn dataField="description" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabOperacoes.tabela.Descricao}</TableHeaderColumn>
    <TableHeaderColumn dataField="external_load_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabOperacoes.tabela.CargaExterna}</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.PTBR.ReferenciasPTBR.tabOperacoes.tabela.Acoes}</TableHeaderColumn>

  </BootstrapTable>
  <PtbrOperationsEditModal handleAlert={self.props.handleAlert} modal_props={self.state.modal_props} data_ptbr_operation={self.state.data_ptbr_operation} refreshTable={self.props.refreshTable} />
</div>
    );
  }
}

export default PtbrOperationsTab;



// WEBPACK FOOTER //
// ./src/Components/Ptbr/Elements/PtbrOperationsTab.js